import { Component, OnInit } from '@angular/core';
import { CartService, CartRow, SelectedCustomerService, GungFlowService } from 'gung-standard';
import { AssignOrderRowsJeevesComponent } from 'gung-standard-jeeves';
import { first, forkJoin } from 'rxjs';

@Component({
  selector: 'cult-assign-order-rows-cult',
  templateUrl: './assign-order-rows-cult.component.html',
  styleUrls: ['./assign-order-rows-cult.component.scss']
})
export class AssignOrderRowsCultComponent extends AssignOrderRowsJeevesComponent implements OnInit {
  constructor(
    cartService: CartService,
    private selectedCustomerService: SelectedCustomerService,
    protected flowService: GungFlowService
  ) {
    super(cartService);
  }

  protected handleCart(rows: CartRow[]) {
    // ensure kundrabatt set on rows
    forkJoin([
      this.selectedCustomerService.getSelectedCustomer().pipe(first()),
      this.flowService.getSelectedFlow().pipe(first())
    ]).subscribe(([selectedCustomer, flow]) => {
      if (flow.isReturnOrder) {
        rows = JSON.parse(JSON.stringify(rows)).map(row => {
          row.extra.orp = {
            ...(row.extra.orp || {}),
            lagstalle: '10'
          };
          return row;
        });
      }

      // -------REMOVED AFTER MEETING WITH RUBIN 30/4 2024 --------
      // ------- If a customer has a pricelist we dont want to append the customer discount over this ---------
      /*
      if (selectedCustomer.extra.kus.kundrabatt && '' + selectedCustomer.extra.kus.kundrabatt !== '0') {
        rows = rows.map(row => {
          return {
            ...row,
            extra: {
              ...row.extra,
              orp: {
                ...(row.extra.orp || {}),
                kundrabatt: row.extra.orp?.kundrabatt ? row.extra.orp.kundrabatt : selectedCustomer.extra.kus.kundrabatt
              }
            }
          };
        });
      }
      */
      super.handleCart(rows);
    });
  }
}
